<template>
  <div>
    <div class="columns is-vcentered is-gapless is-padding-right is-border-bottom has-bg-light">
      <div class="column">
        <div class="is-tab-like is-tab-like--btnactivetransparent is-marginless-bottom columns ">
          <a class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
              @click="tab = 'reserved'" :class="{'is-active': tab === 'reserved'}">Réservées ({{reservedSales.length}})</a>
          <a class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
              @click="tab = 'acted'" :class="{'is-active': tab === 'acted'}">Actées ({{actedSales.length}})</a>
          <a class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
              @click="tab = 'canceled'" :class="{'is-active': tab === 'canceled'}">Annulées ({{canceledSales.length}})</a>
        </div>
      </div>
    </div>
    <table-h-scroll v-if="salesList && salesList.length"
      :has-sticky="true"
      :sticky-styles="stickyStyles"
      :sticky-datas="stickyDatas">
      <table class="table is-fullwidth is-last-fixed-small is-marginless-bottom is-radius-bottom-left is-radius-bottom-right has-actionsontd"
        >
        <thead>
          <tr class="is-size-6">
            <th>Ref. ADV</th>
            <th>Date de réservation</th>
            <th>Lot</th>
            <th>Programme</th>
            <th v-if="isAdmin && isDistributeurMode">Promoteur</th>
            <th>Aquéreur</th>
            <th>Prix de vente</th>
            <th>Date acte</th>
            <th v-if="displayRemuneration">Taux com. vendeur</th>
            <th v-if="displayRemuneration">Com vendeur</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="s in salesList" :key="s.pk" class="is-size-6">
            <td class="is-cell-hoverable">
              <router-link :to="{name: 'AdvInfos', params: {id: s.pk}}" class="fullLink">
                {{s.ref}}
              </router-link>
            </td>
            <td>
              <span v-if="s.signature_date">{{s.signature_date|date}}</span>
              <span v-else>N.C</span>
            </td>
            <td class="is-cell-hoverable">
              <router-link :to="{name: 'LotVue', params: {id: s.lot}}" class="fullLink">
                {{s.lot_ref}}
              </router-link>
            </td>
            <td>{{s.program_name}}</td>
            <td v-if="isAdmin && isDistributeurMode">{{s.promoteur_name}}</td>
            <td class="is-cell-hoverable">
              <router-link :to="{name: 'ContactVue', params: {id: s.buyer}}" class="fullLink">
                {{s.buyer_name|smallName}}
              </router-link>
            </td>
            <td>{{s.sale_price_with_discount | prettyPrice}} {{$currency}}</td>
            <td><span v-if="s.sale_date">{{s.sale_date | date}}</span><span v-else>--</span></td>
            <td v-if="displayRemuneration"><span v-if="s.seller_share">{{s.seller_share}} %</span><span v-else>--</span></td>
            <td v-if="displayRemuneration"><span v-if="s.seller_share && s.sale_price_with_discount">{{calculCom(s) | prettyPrice}} {{$currency}}</span><span v-else>--</span></td>
            <td class="has-text-centered actions">
                <display-button-list :forceDropDown="false" :buttons="advButtonList" :data="s"
                                    ></display-button-list>
            </td>
          </tr>
          <tr class="empty empty--row" v-for="n in salesList.length < 2 ? 2 - salesList.length : 0 " :key="n"><td class="is-borderless"></td></tr>
        </tbody>
      </table>
    </table-h-scroll>
    <div class="column" v-else>Aucune vente à afficher</div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { DefaultValues, TableHeaderSticky } from '@/mixins'
  import { downloadURI } from '@/utils'
  import { orderBy } from 'lodash'
  import moment from 'moment'

  export default {
    name: 'VentePanel',
    mixins: [DefaultValues, TableHeaderSticky],
    data () {
      return {
        tab: 'reserved',
        advButtonList: [
          {
            icon: 'fa-eye',
            text: 'Voir',
            action: (advPk) => {
              this.goToAdvView(advPk)
            }
          },
          {
            icon: 'fa-file-excel',
            text: 'Export xls',
            display: (adv) => {
              return this.isAdmin
            },
            action: (advPk, data) => {
              const apiUrl = this.$configs.APIROOT
              const exportURl = `${apiUrl}/export/adv?pk[]=${advPk}`
              const ref = data.ref
              downloadURI(exportURl, `ADV-N°${ref}-export.xlsx`)
            }
          }
        ]
      }
    },
    props: {
      sales: {
        type: Array,
        required: true,
        default: []
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'isManager', 'isDistributeurMode', 'displayRemuneration']),
      salesList () {
        if (this.tab === 'acted') {
          return this.actedSales
        } else if (this.tab === 'canceled') {
          return this.canceledSales
        } else {
          return this.reservedSales
        }
      },
      reservedSales () {
        return orderBy(this.sales.filter(x => x.status === 'reserved'), s => moment(s.created_on).format('x'), ['desc'])
      },
      actedSales () {
        return orderBy(this.sales.filter(x => x.status === 'sold'), s => moment(s.created_on).format('x'), ['desc'])
      },
      canceledSales () {
        return orderBy(this.sales.filter(x => ['canceled_by_admin', 'canceled_by_user'].includes(x.status)), s => moment(s.created_on).format('x'), ['desc'])
      }
    },
    methods: {
      goToAdvView (advPk) {
        this.$router.push({name: 'AdvInfos', params: {id: advPk}})
      },
      calculCom (v) {
        return v.sale_price_with_discount / 100 * v.seller_share
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/company/CompanyVuePanels/VentePanel.vue